import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { variant } from 'styled-system';
import { isMobile } from 'react-device-detect';
import Link from '@material-ui/core/Link';

const ButtonBase = styled('button')(
  {
    minWidth: isMobile ? 144 : 160,
    padding: '0 20px',
    height: '40px',
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '20px',
    textAlign: 'center',
    fontStyle: 'normal',
    lineHeight: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    appearance: 'none',
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
  variant({
    variants: {
      primary: {
        color: '#ffffff',
        border: 'none',
        //backgroundColor: '#478eb5', //$Blue6
        backgroundColor: '#013957', //$Blue1
        '&:disabled': {
          opacity: '0.6',
          //backgroundColor: '#478eb5', //#Blue6
          backgroundColor: '#57a4cc', //#Blue9
          cursor: 'not-allowed',
        },
        '&:hover': {
          //backgroundColor: '#10587f', //#Blue4
          backgroundColor: '#106c9d', //#Blue5
          textDecoration: 'none'
        },
        '&:focus': {
          backgroundColor: '#013957', //#Blue1
        },
      },
      primarySolidOutlined: {
        color: '#013957', //#Blue4
        backgroundColor: '#ffffff',
        border: 'solid 1px #10587f',

        '&:disabled': {
          opacity: '0.6',
          //backgroundColor: '#478eb5', //#Blue6
          backgroundColor: '#57a4cc', //#Blue9
          cursor: 'not-allowed',
        },
        '&:hover': {
          border: 'none', //#Blue4
          color: '#ffffff', //#Blue4
          backgroundColor: '#35b9b6',
        },
        '&:focus': {
          color: '#013957', //#Blue4
          backgroundColor: '#ffffff',
          border: 'solid 3px #10587f',
        },
      },
      primaryOutlined: {
        color: '#478eb5', //$Blue6
        border: 'solid 1px #478eb5', //$Blue6
        backgroundColor: '#ffffff',
        textAlign:'center',
        '&:disabled': {
          border: 'solid 1px #478eb5', //$Blue6
          opacity: '0.6',
          cursor: 'not-allowed',
        },
        '&:hover': {
          border: 'solid 1px #10587f', //#Blue4
          color: '#10587f', //#Blue4
        },
        '&:focus': {
          border: 'solid 1px #013957', //#Blue1
          color: '#013957', //#Blue1
        },
      },
      primaryOutlined2: {
        color: '#013957', 
        border: 'solid 1px #013957', 
        backgroundColor: '#ffffff',
        '&:disabled': {
          border: 'solid 1px #57a4cc',
          color: '#57a4cc', 
          opacity: '0.6',
          cursor: 'not-allowed',
        },
        '&:hover': {
          border: 'solid 1px #35b9b6', 
          color: '#ffffff', 
          backgroundColor: '#35b9b6'
        },
        '&:focus': {
          border: 'solid 1px #013957', //#Blue1
          color: '#013957', //#Blue1
        },
      },
      secondary: {
        color: '#ffffff',
        border: 'none',
        backgroundColor: '#7cd4d2', //$
        '&:disabled': {
          opacity: '0.6',
          backgroundColor: '#7cd4d2', //#
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: '#1daeab', //#
        },
        '&:focus': {
          backgroundColor: '#35b9b6', //#Menta
        },
      },
    },
  })
);

const Button = props => (
  <ThemeProvider theme={{}}>
    <Link
      href={props.direction}
      className={props.linkStyle ? props.linkStyle : null}
      style={{ textDecoration: 'none' }}
    >
      <ButtonBase 
        disabled={props.isValid !== undefined && !props.isValid}
        className={props.buttonStyle ? props.buttonStyle : null}
        {...props}
      >
        {props.children}
      </ButtonBase>
    </Link>
  </ThemeProvider>
)

export default Button;
